import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";
const func = import.meta.env.DEV ? createWebHashHistory : createWebHistory;
const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL),
  history: func(import.meta.env.BASE_URL),
  routes: [
    {
      path: "",
      name: "index",
      component: () => import("@/pages/index/views/login-page.vue"),
    },
    {
      path: "/not-found",
      name: "not-found",
      component: () => import("@/pages/index/views/not-found-page.vue"),
    },
  ],
});
router.beforeEach((to, from) => {
  if (to.matched.length === 0) {
    // 如果未匹配到路由
    // from.name ? next({ name: from.name }) : next('/login')
    return { name: "not-found", bad_path: to.path };
  }
});

router.onError((to, from) => {
  console.log("error", to, from);
});
export default router;
